var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 378,
    viewBox: "0 0 466 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.863281 28.834V349.137C0.863281 365.039 13.7588 377.944 29.6611 377.944H436.356C452.239 377.944 465.135 365.039 465.135 349.137V28.834C465.135 12.9321 452.239 0.0556641 436.356 0.0556641H29.6611C13.7588 0.0556641 0.863281 12.9321 0.863281 28.834ZM120.702 56.5435H90.167V27.1255H120.702V56.5435ZM174.021 56.5435H143.486V27.1255H174.021V56.5435ZM36.8579 87.25H429.159V341.95H36.8579V87.25ZM36.8579 27.1255H67.3828V56.5435H36.8579V27.1255Z",
    fill: "#35424A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.934 206.268L198.037 161.243V179.235L143.935 210.973L198.037 238.93V257.113L125.934 217.444V206.268ZM207.81 277.502H224.19L264.337 142.602H248.033L207.81 277.502ZM274.206 161.243V179.235L328.308 210.973L274.206 238.93V257.113L346.31 217.444V206.268L274.206 161.243Z",
    fill: "#35424A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.edbaa7d8.svg";
export { ForwardRef as ReactComponent };